<template>
  <v-container fluid class="zatv">

    <!-- filter -->
    <div class="z-filter">
      <!-- Kad je ugradjen u analizu, konto i datum dolaze odozgo pa se ovdje
           samo ispisuju - da se isti uvjet ne bira dvaput. -->
      <template v-if="ugradjen">
        <span class="z-uvjet">
          Konto <b>{{ konto }}</b>
          <span class="z-sep">·</span>
          na dan <b>{{ localDate(doDatuma) }}</b>
        </span>
      </template>

      <template v-else>
        <v-select
          v-model="konto"
          :items="konta"
          item-text="naziv"
          item-value="od"
          label="Konto"
          outlined dense hide-details
          style="max-width:230px"
        ></v-select>

        <v-text-field
          v-model="doDatuma"
          label="Stanje na dan"
          type="date"
          outlined dense hide-details
          style="max-width:190px"
        ></v-text-field>
      </template>

      <v-text-field
        v-model="trazi"
        label="Traži partnera"
        outlined dense hide-details clearable
        prepend-inner-icon="mdi-magnify"
        style="max-width:250px"
      ></v-text-field>

      <v-btn color="primary" :loading="ucitavam" @click="ucitaj">Učitaj</v-btn>

      <v-btn-toggle v-if="ucitano" v-model="nacin" mandatory dense class="ml-2">
        <v-btn small value="rucno">Ručno</v-btn>
        <v-btn small value="prijedlozi">Prijedlozi</v-btn>
      </v-btn-toggle>

      <v-spacer></v-spacer>
      <span v-if="ucitano" class="z-broj">
        {{ partneriFiltrirani.length }} partnera · {{ ukupnoOtvorenih }} otvorenih stavaka
      </span>
    </div>

    <div v-if="!ucitano" class="z-prazno">
      Odaberi konto i datum pa pritisni Učitaj.
    </div>

    <!-- automatski prijedlozi -->
    <div v-else-if="nacin === 'prijedlozi'" class="z-prijedlozi">
      <div class="z-sazetak">
        <button
          v-for="r in razine"
          :key="r.broj"
          type="button"
          class="z-kut"
          :class="{aktivan: razinaFilter === r.broj}"
          @click="razinaFilter = razinaFilter === r.broj ? null : r.broj"
        >
          <span>{{ r.naziv }}</span>
          <b>{{ sazetakP['razina' + r.broj] || 0 }}</b>
          <em>{{ r.opis }}</em>
        </button>
        <v-spacer></v-spacer>
        <div class="z-akcija-p">
          <span class="z-mali">Označeno {{ brojOznacenihP }} od {{ prijedloziFiltrirani.length }}</span>
          <v-btn small text @click="oznaciSve(true)">Označi sve</v-btn>
          <v-btn small text @click="oznaciSve(false)">Odznači</v-btn>
          <v-btn color="primary" :disabled="brojOznacenihP === 0" :loading="povezujem" @click="poveziPrijedloge">
            Poveži označeno
          </v-btn>
        </div>
      </div>

      <div v-if="ucitavamP" class="z-prazno">Računam prijedloge…</div>
      <div v-else-if="prijedloziFiltrirani.length === 0" class="z-prazno">
        Nema prijedloga. Pritisni <b>Prijedlozi</b> ponovno ili prijeđi na ručno povezivanje.
      </div>

      <div v-else class="z-lista-p">
        <div
          v-for="(p, i) in prijedloziFiltrirani"
          :key="p.uplataId + '-' + i"
          class="z-prijedlog"
          :class="['razina' + p.razina, {cek: oznaceniP[p.uplataId]}]"
        >
          <label class="z-pcek">
            <input type="checkbox" :checked="!!oznaceniP[p.uplataId]" @change="prebaciPrijedlog(p)">
          </label>

          <div class="z-ppartner">
            <span class="z-ime">{{ p.partnerName || '(bez naziva)' }}</span>
            <span class="z-oib"><em>OIB</em> {{ p.partnerVATID || '—' }}</span>
          </div>

          <div class="z-puplata">
            <span class="z-oznaka">uplata</span>
            {{ dokument(p.uplata) }} · {{ localDate(p.uplata.BookingDate) }}
            <b>{{ novac(p.uplata.otvoreno) }}</b>
          </div>

          <div class="z-pracuni">
            <span class="z-oznaka">{{ p.racuni.length === 1 ? 'račun' : p.racuni.length + ' računa' }}</span>
            <span v-for="r in p.racuni" :key="r.id" class="z-pracun">
              {{ dokument(r) }} · {{ localDate(r.BookingDate) }} <b>{{ novac(r.otvoreno) }}</b>
            </span>
            <select
              v-if="p.razina === 2 && p.kandidati && p.kandidati.length > 1"
              class="z-izbor"
              @change="odaberiKandidata(p, $event.target.value)"
            >
              <option v-for="k in p.kandidati" :key="k.id" :value="k.id">
                {{ dokument(k) }} · {{ localDate(k.BookingDate) }} · {{ novac(k.otvoreno) }}
              </option>
            </select>
          </div>

          <div class="z-pznak">{{ znakRazine(p.razina) }}</div>
        </div>
      </div>
    </div>

    <div v-else class="z-glavno">

      <!-- lijevo: partneri -->
      <div class="z-partneri">
        <div class="z-zaglavlje">Partneri</div>
        <div class="z-lista">
          <button
            v-for="p in partneriFiltrirani"
            :key="p.partnerVATID || '-'"
            type="button"
            class="z-partner"
            :class="{odabran: odabraniPartner === p.partnerVATID}"
            @click="odaberiPartnera(p)"
          >
            <span class="z-ime">{{ p.partnerName || '(bez naziva)' }}</span>
            <span class="z-oib"><em>OIB</em> {{ p.partnerVATID || '—' }}</span>
            <span class="z-stat">
              <span class="z-stat-dio">
                <b>{{ p.racuna }}</b>
                <span class="z-rijec">{{ mnozina(p.racuna, 'račun', 'računa', 'računa') }}</span>
                <span class="z-stat-izn">{{ novac(p.iznosRacuna) }}</span>
              </span>
              <span class="z-stat-dio">
                <b>{{ p.uplata }}</b>
                <span class="z-rijec">{{ mnozina(p.uplata, 'uplata', 'uplate', 'uplata') }}</span>
                <span class="z-stat-izn">{{ novac(p.iznosUplata) }}</span>
              </span>
            </span>
          </button>
        </div>
      </div>

      <!-- desno: racuni i uplate odabranog partnera -->
      <div class="z-rad">
        <div v-if="!odabraniPartner" class="z-prazno">
          Odaberi partnera s liste lijevo.
        </div>

        <template v-else>
          <div class="z-naslov">
            {{ imeOdabranog }}
            <span class="z-oib2"><em>OIB</em> {{ odabraniPartner }}</span>
          </div>

          <div class="z-dvije">
            <!-- racuni -->
            <div class="z-strana">
              <div class="z-zaglavlje">
                {{ naziviStrana.racuni }}
                <span class="z-mali">{{ racuni.length }}</span>
              </div>
              <div class="z-lista">
                <label v-for="d in racuni" :key="d.id" class="z-stavka" :class="{cek: oznaceniR[d.id]}">
                  <input type="checkbox" :checked="!!oznaceniR[d.id]" @change="prebaci('R', d)">
                  <span class="z-dok">{{ dokument(d) }}</span>
                  <span class="z-dat">{{ localDate(d.BookingDate) }}</span>
                  <span class="z-dosp" :class="{kasni: dana(d) > 0}">{{ dana(d) === null ? '' : dana(d) + 'd' }}</span>
                  <span class="z-opis">{{ d.Description }}</span>
                  <span class="z-izn">{{ novac(d.otvoreno) }}</span>
                </label>
              </div>
              <div class="z-zbroj">
                Označeno <b>{{ novac(zbrojR) }}</b>
                <span class="z-mali">od {{ novac(ukupnoR) }}</span>
              </div>
            </div>

            <!-- uplate -->
            <div class="z-strana">
              <div class="z-zaglavlje">
                {{ naziviStrana.uplate }}
                <span class="z-mali">{{ uplate.length }}</span>
              </div>
              <div class="z-lista">
                <label v-for="d in uplate" :key="d.id" class="z-stavka" :class="{cek: oznaceniU[d.id]}">
                  <input type="checkbox" :checked="!!oznaceniU[d.id]" @change="prebaci('U', d)">
                  <span class="z-dok">{{ dokument(d) }}</span>
                  <span class="z-dat">{{ localDate(d.BookingDate) }}</span>
                  <span class="z-dosp"></span>
                  <span class="z-opis">{{ d.Description }}</span>
                  <span class="z-izn">{{ novac(d.otvoreno) }}</span>
                </label>
              </div>
              <div class="z-zbroj">
                Označeno <b>{{ novac(zbrojU) }}</b>
                <span class="z-mali">od {{ novac(ukupnoU) }}</span>
              </div>
            </div>
          </div>

          <!-- traka za povezivanje -->
          <div class="z-akcija">
            <span class="z-razlika" :class="stanjeRazlike">
              Razlika {{ novac(razlika) }}
              <em v-if="Math.abs(razlika) < 0.005 && zbrojR > 0">zatvara se u cijelosti</em>
              <em v-else-if="zbrojR > 0 && zbrojU > 0">zatvorit će se {{ novac(Math.min(zbrojR, zbrojU)) }}</em>
            </span>
            <v-spacer></v-spacer>
            <v-btn small text @click="ocisti" :disabled="!imaOznacenih">Očisti odabir</v-btn>
            <v-btn
              color="primary"
              :disabled="!mozePovezati"
              :loading="povezujem"
              @click="povezi"
            >Poveži</v-btn>
          </div>

          <div v-if="poruka" class="z-poruka" :class="{lose: porukaLose}">{{ poruka }}</div>
        </template>
      </div>
    </div>

    <v-snackbar v-model="snackbar" bottom :timeout="4000" :color="snackColor">{{ snackTekst }}</v-snackbar>
  </v-container>
</template>

<script>
// Zatvaranje otvorenih stavaka - jedan ekran za sve partnere.
//
// Dosad se povezivalo iz kartice otvorenih stavaka, partner po partner. Kod
// jedne firme to je 286 otvaranja ekrana za 995 stavaka, pa je posao trajao
// danima. Ovdje partneri stoje u listi lijevo, a rad se odvija desno bez
// napustanja ekrana.
//
// Povezuje se odabirom s obje strane. Zatvara se manji od dva zbroja, redom od
// najstarijeg racuna - to pokriva i slucaj jedne uplate za vise racuna i
// djelomicno placanje.
//
// Glavna knjiga se ne mijenja; veze idu u MainLedgerZatvaranja.

import MainLedgerZatvaranjeService from '@/services/MainLedgerZatvaranjeService'
import dateFormat from '@/snippets/dateFormat'
import dayjs from 'dayjs'

const n2 = (v) => Math.round((parseFloat(v) || 0) * 100) / 100

export default {
  name: 'MainLedgerZatvaranje',
  // `head` je mainledgerAna iz analize. Kad je zadan, konto, datum i partner
  // dolaze odande i ne biraju se ponovno. Bez njega komponenta radi samostalno.
  props: ['head'],
  data () {
    return {
      konto: '1200',
      konta: [
        {od: '1200', naziv: '1200 Kupci'},
        {od: '2200', naziv: '2200 Dobavljači'}
      ],
      doDatuma: dayjs().format('YYYY-MM-DD'),
      trazi: '',
      ucitavam: false,
      ucitano: false,
      povezujem: false,
      dokumenti: [],
      partneri: [],
      odabraniPartner: null,
      imeOdabranog: '',
      oznaceniR: {},
      oznaceniU: {},
      nacin: 'rucno',
      ucitavamP: false,
      prijedlozi: [],
      sazetakP: {},
      oznaceniP: {},
      razinaFilter: null,
      razine: [
        {broj: 1, naziv: 'Razina 1', opis: 'točan iznos, jedan račun'},
        {broj: 2, naziv: 'Razina 2', opis: 'točan iznos, više kandidata'},
        {broj: 3, naziv: 'Razina 3', opis: 'zbroj računa = uplata'}
      ],
      poruka: '',
      porukaLose: false,
      snackbar: false,
      snackTekst: '',
      snackColor: 'green',
      ugradjen: false
    }
  },
  mounted () {
    if (!this.head || !this.head.fromAccount) { return }
    this.ugradjen = true
    // Saldakonto se cita iz raspona konta postavljenog gore. Uzima se prve
    // cetiri znamenke jer se zatvaranje uvijek dogadja unutar jednog saldakonta.
    this.konto = String(this.head.fromAccount).substring(0, 4)
    if (this.head.docToDate) { this.doDatuma = dayjs(this.head.docToDate).format('YYYY-MM-DD') }
    this.ucitaj()
  },
  computed: {
    naziviStrana () {
      return this.konto === '2200'
        ? {racuni: 'Ulazni računi', uplate: 'Plaćanja'}
        : {racuni: 'Izlazni računi', uplate: 'Uplate'}
    },
    partneriFiltrirani () {
      const t = (this.trazi || '').trim().toLowerCase()
      if (!t) { return this.partneri }
      return this.partneri.filter(p =>
        String(p.partnerName || '').toLowerCase().indexOf(t) !== -1 ||
        String(p.partnerVATID || '').indexOf(t) !== -1)
    },
    ukupnoOtvorenih () {
      return this.dokumenti.length
    },
    racuni () {
      return this.dokumenti.filter(d => d.partnerVATID === this.odabraniPartner && d.jeRacun)
    },
    uplate () {
      return this.dokumenti.filter(d => d.partnerVATID === this.odabraniPartner && !d.jeRacun)
    },
    zbrojR () {
      return n2(this.racuni.filter(d => this.oznaceniR[d.id]).reduce((a, d) => a + d.otvoreno, 0))
    },
    zbrojU () {
      return n2(this.uplate.filter(d => this.oznaceniU[d.id]).reduce((a, d) => a + d.otvoreno, 0))
    },
    ukupnoR () {
      return n2(this.racuni.reduce((a, d) => a + d.otvoreno, 0))
    },
    ukupnoU () {
      return n2(this.uplate.reduce((a, d) => a + d.otvoreno, 0))
    },
    razlika () {
      return n2(this.zbrojR - this.zbrojU)
    },
    stanjeRazlike () {
      if (this.zbrojR === 0 || this.zbrojU === 0) { return '' }
      return Math.abs(this.razlika) < 0.005 ? 'tocno' : 'djelomicno'
    },
    imaOznacenih () {
      return this.zbrojR > 0 || this.zbrojU > 0
    },
    mozePovezati () {
      return this.zbrojR > 0.005 && this.zbrojU > 0.005 && !this.povezujem
    },
    prijedloziFiltrirani () {
      const t = (this.trazi || '').trim().toLowerCase()
      return this.prijedlozi.filter(p => {
        if (this.razinaFilter && p.razina !== this.razinaFilter) { return false }
        if (!t) { return true }
        return String(p.partnerName || '').toLowerCase().indexOf(t) !== -1 ||
          String(p.partnerVATID || '').indexOf(t) !== -1
      })
    },
    brojOznacenihP () {
      return this.prijedloziFiltrirani.filter(p => this.oznaceniP[p.uplataId]).length
    }
  },
  watch: {
    // Prijedlozi se racunaju tek kad zatrebaju - za 27.000 stavaka je to
    // sekunda posla, pa nema smisla raditi ga pri svakom ucitavanju.
    nacin (novi) {
      if (novi === 'prijedlozi' && this.prijedlozi.length === 0) { this.ucitajPrijedloge() }
    }
  },
  methods: {
    novac (v) {
      return n2(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    localDate (d) {
      return d ? dateFormat(d) : ''
    },
    // Hrvatska mnozina: 1 racun, 2-4 racuna, 5+ racuna; 11-14 idu kao 5+.
    mnozina (n, jedan, dvaDoCetiri, pet) {
      const x = Math.abs(parseInt(n) || 0)
      const zadnja = x % 10
      const zadnjeDvije = x % 100
      if (zadnja === 1 && zadnjeDvije !== 11) { return jedan }
      if (zadnja >= 2 && zadnja <= 4 && (zadnjeDvije < 12 || zadnjeDvije > 14)) { return dvaDoCetiri }
      return pet
    },
    dokument (d) {
      const book = d.BookName ? String(d.BookName) : ''
      if (book === 'BS') { return 'Izv. ' + (d.BookID ? parseInt(d.BookID) : '') }
      const br = this.konto === '2200'
        ? parseInt(d.invoiceInNumber) || 0
        : parseInt(d.invoiceOutNumber) || 0
      return (book + ' ' + (br || (d.BookID ? parseInt(d.BookID) : ''))).trim()
    },
    // Opisno, kao na kartici - koliko je proslo od dospijeca do odabranog dana.
    dana (d) {
      if (!d.InvoicePaymentDeadlineDate || !this.doDatuma) { return null }
      return dayjs(this.doDatuma).diff(dayjs(d.InvoicePaymentDeadlineDate), 'day')
    },

    async ucitaj () {
      this.ucitavam = true
      this.poruka = ''
      try {
        const {data} = await MainLedgerZatvaranjeService.nepovezane({
          CompanyId: this.$store.state.companyid,
          fromAccount: this.konto,
          toAccount: this.konto + '9999',
          doDatuma: this.doDatuma
        })
        this.dokumenti = data.dokumenti || []
        // Partner je zanimljiv samo ako ima obje strane - inace se nema sto povezati.
        this.partneri = (data.partneri || []).filter(p => p.racuna > 0 && p.uplata > 0)
        this.ucitano = true
        this.odabraniPartner = null
        this.ocisti()
        // Ako je gore odabran partner, otvara se odmah taj - inace bi ga korisnik
        // morao traziti po listi iako ga je vec odabrao.
        const gore = this.head && this.head.partnerVATID ? this.head.partnerVATID : null
        if (gore) {
          const p = this.partneri.find(x => x.partnerVATID === gore)
          if (p) { this.odaberiPartnera(p) } else { this.trazi = gore }
        }
        if (this.partneri.length === 0) {
          this.javi('Nema partnera koji imaju i otvoren račun i otvorenu uplatu.', 'orange')
        }
      } catch (error) {
        this.javi('Greška kod čitanja nepovezanih stavaka.', 'red')
      }
      this.ucitavam = false
    },

    odaberiPartnera (p) {
      this.odabraniPartner = p.partnerVATID
      this.imeOdabranog = p.partnerName || ''
      this.ocisti()
    },
    prebaci (strana, d) {
      const mapa = strana === 'R' ? 'oznaceniR' : 'oznaceniU'
      this.$set(this[mapa], d.id, !this[mapa][d.id])
      this.poruka = ''
    },
    ocisti () {
      this.oznaceniR = {}
      this.oznaceniU = {}
      this.poruka = ''
    },

    // Racuni se zatvaraju redom od najstarijeg, uplate isto. Zatvara se manji
    // od dva zbroja, pa zadnji dokument u nizu ostaje djelomicno otvoren.
    slozeniVeze () {
      const r = this.racuni.filter(d => this.oznaceniR[d.id])
        .map(d => ({id: d.id, ostatak: d.otvoreno}))
        .sort((a, b) => a.id - b.id)
      const u = this.uplate.filter(d => this.oznaceniU[d.id])
        .map(d => ({id: d.id, ostatak: d.otvoreno}))
        .sort((a, b) => a.id - b.id)
      const veze = []
      let i = 0
      u.forEach(up => {
        while (up.ostatak > 0.005 && i < r.length) {
          const rac = r[i]
          if (rac.ostatak <= 0.005) { i += 1; continue }
          const iznos = n2(Math.min(rac.ostatak, up.ostatak))
          veze.push({racunId: rac.id, uplataId: up.id, iznos: iznos})
          rac.ostatak = n2(rac.ostatak - iznos)
          up.ostatak = n2(up.ostatak - iznos)
        }
      })
      return veze
    },

    async povezi () {
      const veze = this.slozeniVeze()
      if (veze.length === 0) { return }
      this.povezujem = true
      try {
        const {data} = await MainLedgerZatvaranjeService.povezi({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          izvor: 'rucno',
          UserId: this.$store.state.user ? this.$store.state.user.id : null,
          email: this.$store.state.user ? this.$store.state.user.email : null,
          veze: veze
        })
        const odbijeno = data.odbijene ? data.odbijene.length : 0
        if (data.upisano > 0) {
          this.javi('Povezano ' + data.upisano + (data.upisano === 1 ? ' veza.' : ' veza.'), 'green')
        }
        if (odbijeno > 0) {
          this.poruka = 'Odbijeno ' + odbijeno + ': ' + data.odbijene[0].razlog
          this.porukaLose = true
        }
        await this.osvjezi()
      } catch (error) {
        this.javi('Greška kod povezivanja.', 'red')
      }
      this.povezujem = false
    },

    // Nakon povezivanja se osvjezava samo popis, a odabrani partner ostaje -
    // da se moze nastaviti raditi na istom partneru bez trazenja po listi.
    async osvjezi () {
      const zapamti = this.odabraniPartner
      const ime = this.imeOdabranog
      await this.ucitaj()
      if (zapamti && this.partneri.some(p => p.partnerVATID === zapamti)) {
        this.odabraniPartner = zapamti
        this.imeOdabranog = ime
      }
    },

    znakRazine (r) {
      return {1: '✓✓', 2: '✓', 3: 'Σ'}[r] || ''
    },

    async ucitajPrijedloge () {
      this.ucitavamP = true
      try {
        const {data} = await MainLedgerZatvaranjeService.prijedlozi({
          CompanyId: this.$store.state.companyid,
          fromAccount: this.konto,
          toAccount: this.konto + '9999',
          doDatuma: this.doDatuma
        })
        this.prijedlozi = data.prijedlozi || []
        this.sazetakP = data.sazetak || {}
        // Razina 1 je oznacena unaprijed - tu je tocno jedan racun istog iznosa,
        // pa je najcesci potez potvrditi sve odjednom. Razine 2 i 3 traze pogled.
        const ozn = {}
        this.prijedlozi.forEach(p => { if (p.razina === 1) { ozn[p.uplataId] = true } })
        this.oznaceniP = ozn
      } catch (error) {
        this.javi('Greška kod računanja prijedloga.', 'red')
      }
      this.ucitavamP = false
    },

    prebaciPrijedlog (p) {
      this.$set(this.oznaceniP, p.uplataId, !this.oznaceniP[p.uplataId])
    },
    oznaciSve (da) {
      const ozn = Object.assign({}, this.oznaceniP)
      this.prijedloziFiltrirani.forEach(p => { ozn[p.uplataId] = da })
      this.oznaceniP = ozn
    },
    // Kod razine 2 korisnik bira koji je racun, pa se prijedlog prepise.
    odaberiKandidata (p, id) {
      const k = (p.kandidati || []).find(x => String(x.id) === String(id))
      if (k) { this.$set(p, 'racuni', [k]) }
    },

    async poveziPrijedloge () {
      const odabrani = this.prijedloziFiltrirani.filter(p => this.oznaceniP[p.uplataId])
      if (odabrani.length === 0) { return }
      const veze = []
      odabrani.forEach(p => {
        p.racuni.forEach(r => veze.push({racunId: r.id, uplataId: p.uplataId, iznos: r.otvoreno}))
      })
      this.povezujem = true
      try {
        const {data} = await MainLedgerZatvaranjeService.povezi({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          izvor: 'auto',
          UserId: this.$store.state.user ? this.$store.state.user.id : null,
          email: this.$store.state.user ? this.$store.state.user.email : null,
          veze: veze
        })
        const odbijeno = data.odbijene ? data.odbijene.length : 0
        this.javi('Povezano ' + data.upisano + ' veza iz ' + odabrani.length + ' prijedloga.' +
          (odbijeno ? ' Odbijeno ' + odbijeno + '.' : ''), odbijeno ? 'orange' : 'green')
        this.prijedlozi = []
        this.oznaceniP = {}
        await this.ucitaj()
        await this.ucitajPrijedloge()
      } catch (error) {
        this.javi('Greška kod povezivanja prijedloga.', 'red')
      }
      this.povezujem = false
    },

    javi (tekst, boja) {
      this.snackTekst = tekst
      this.snackColor = boja || 'green'
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
.zatv { font-size: 15px; color: #191d1c; }

.z-filter {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 4px;
  border-bottom: 1px solid #c7cfcb;
}
.z-broj { font-size: 13px; color: #79827e; }
/* uvjeti koji dolaze iz analize - ispisuju se, ne biraju */
.z-uvjet { font-size: 14px; color: #4a524f; }
.z-uvjet b { color: #14534c; font-size: 15px; }
.z-sep { color: #79827e; padding: 0 6px; }

.z-prazno {
  padding: 30px 10px;
  color: #79827e;
  font-size: 14px;
}

.z-glavno {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 16px;
  padding-top: 12px;
}

.z-zaglavlje {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .08em;
  color: #79827e;
  font-weight: 600;
  padding: 6px 8px;
  border-bottom: 1px solid #c7cfcb;
}
.z-mali { font-size: 12px; color: #79827e; font-weight: 400; padding-left: 8px; text-transform: none; letter-spacing: 0; }

/* ---------- lista partnera ---------- */
.z-partneri { border: 1px solid #e2e6e3; border-radius: 2px; }
.z-partneri .z-lista { max-height: 66vh; overflow: auto; }
/* Tri retka jedan ispod drugoga: naziv, OIB, pa sto partner ima otvoreno.
   Prije je OIB bio sitan i svijetlosiv bez oznake, a desno je pisalo "12R 3U"
   - ni jedno se nije dalo procitati ni razumjeti. */
.z-partner {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  row-gap: 2px;
  width: 100%;
  text-align: left;
  border: 0;
  border-bottom: 1px solid #e2e6e3;
  background: transparent;
  padding: 8px 10px;
  cursor: pointer;
  font: inherit;
  color: #191d1c;
}
.z-partner:hover { background: #f1f5f3; }
.z-partner.odabran { background: #e8f0ee; border-left: 3px solid #14534c; padding-left: 7px; }
.z-ime { font-size: 14.5px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* Oznake ("OIB", "računa", "uplata") su male i razmaknute, vrijednosti tamne i
   pune velicine - kontrast oko 8:1 umjesto dosadasnjih 3,9:1. */
.z-oib, .z-oib2 {
  font-size: 13px;
  color: #3d4542;
  font-variant-numeric: tabular-nums;
}
.z-oib em, .z-oib2 em, .z-stat em {
  font-style: normal;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: .07em;
  text-transform: uppercase;
  color: #5d6662;
  padding-right: 4px;
}
.z-stat {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 14px;
  margin-top: 2px;
  font-size: 13px;
  color: #3d4542;
}
.z-stat-dio { white-space: nowrap; }
.z-stat-dio b { font-weight: 700; color: #191d1c; padding-right: 3px; }
.z-rijec { color: #3d4542; padding-right: 6px; }
.z-stat-izn { font-variant-numeric: tabular-nums; font-weight: 600; color: #14534c; }

/* ---------- radna ploha ---------- */
.z-rad { border: 1px solid #e2e6e3; border-radius: 2px; }
.z-naslov {
  font-size: 17px;
  font-weight: 700;
  color: #14534c;
  padding: 8px 10px;
  border-bottom: 1px solid #c7cfcb;
}
.z-oib2 { font-weight: 400; padding-left: 14px; }

.z-dvije { display: grid; grid-template-columns: 1fr 1fr; gap: 0; }
.z-strana { min-width: 0; }
.z-strana + .z-strana { border-left: 1px solid #e2e6e3; }
.z-strana .z-lista { max-height: 50vh; overflow: auto; }

.z-stavka {
  display: grid;
  grid-template-columns: 22px 86px 82px 44px minmax(0, 1fr) 108px;
  align-items: baseline;
  gap: 4px;
  padding: 3px 8px;
  border-bottom: 1px solid #eef1ef;
  cursor: pointer;
  font-size: 13px;
}
.z-stavka:hover { background: #f1f5f3; }
.z-stavka.cek { background: #e8f0ee; }
.z-dok { font-size: 12px; color: #4a524f; white-space: nowrap; }
.z-dat { font-size: 12px; color: #79827e; white-space: nowrap; }
.z-dosp { font-size: 12px; color: #79827e; text-align: right; white-space: nowrap; }
.z-dosp.kasni { color: #8c2f1e; font-weight: 600; }
.z-opis { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #4a524f; }
.z-izn { text-align: right; font-variant-numeric: tabular-nums; font-weight: 600; white-space: nowrap; }

.z-zbroj {
  padding: 6px 8px;
  border-top: 1px solid #c7cfcb;
  background: #fafbfa;
  font-size: 13px;
}
.z-zbroj b { font-variant-numeric: tabular-nums; font-size: 15px; }

/* ---------- traka za povezivanje ---------- */
.z-akcija {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-top: 2px solid #c7cfcb;
  background: #fafbfa;
}
.z-razlika { font-size: 14px; font-variant-numeric: tabular-nums; }
.z-razlika em { font-style: normal; font-size: 12px; color: #79827e; padding-left: 10px; }
.z-razlika.tocno { color: #1f6b43; font-weight: 700; }
.z-razlika.djelomicno { color: #8c5a1e; font-weight: 600; }

.z-poruka { padding: 8px 10px; font-size: 13px; color: #4a524f; }
.z-poruka.lose { color: #8c2f1e; }

/* ---------- prijedlozi ---------- */
.z-prijedlozi { padding-top: 12px; }
.z-sazetak {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 8px 4px 10px;
  border-bottom: 1px solid #c7cfcb;
}
.z-kut {
  display: grid;
  text-align: left;
  border: 1px solid #e2e6e3;
  border-radius: 2px;
  background: #fff;
  padding: 6px 12px;
  cursor: pointer;
  font: inherit;
}
.z-kut:hover { background: #f1f5f3; }
.z-kut.aktivan { border-color: #14534c; background: #e8f0ee; }
.z-kut span { font-size: 11px; text-transform: uppercase; letter-spacing: .08em; color: #79827e; font-weight: 600; }
.z-kut b { font-size: 20px; font-variant-numeric: tabular-nums; }
.z-kut em { font-style: normal; font-size: 11.5px; color: #79827e; }

.z-akcija-p { display: flex; align-items: center; gap: 8px; }

.z-lista-p { max-height: 64vh; overflow: auto; }
.z-prijedlog {
  display: grid;
  grid-template-columns: 30px 220px 280px minmax(0, 1fr) 34px;
  align-items: baseline;
  gap: 8px;
  padding: 6px 4px;
  border-bottom: 1px solid #eef1ef;
  font-size: 13px;
}
.z-prijedlog:hover { background: #f1f5f3; }
.z-prijedlog.cek { background: #e8f0ee; }
.z-prijedlog.razina1 { border-left: 3px solid #1f6b43; padding-left: 4px; }
.z-prijedlog.razina2 { border-left: 3px solid #8c5a1e; padding-left: 4px; }
.z-prijedlog.razina3 { border-left: 3px solid #14534c; padding-left: 4px; }

.z-ppartner { display: grid; min-width: 0; }
.z-puplata, .z-pracuni { min-width: 0; }
.z-oznaka {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: #79827e;
  padding-right: 6px;
}
.z-pracun { display: block; }
.z-puplata b, .z-pracun b { font-variant-numeric: tabular-nums; }
.z-izbor {
  margin-top: 3px;
  font: inherit;
  font-size: 12px;
  border: 1px solid #c7cfcb;
  border-radius: 2px;
  padding: 2px 4px;
  max-width: 100%;
}
.z-pznak { text-align: right; color: #79827e; font-size: 12px; }

@media (max-width: 1100px) {
  .z-glavno { grid-template-columns: 1fr; }
  .z-dvije { grid-template-columns: 1fr; }
  .z-strana + .z-strana { border-left: 0; border-top: 1px solid #c7cfcb; }
}
</style>
